import { observer } from 'mobx-react';
import React from 'react';
import ModifierOption from '../../components/ModifierOption/ModifierOption';
import modifiersStore from '../../store/modifiersStore';
import { MODIFIERS_CHECKBOX } from '../../types/modifiers';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import { appStore } from 'src/mobx/appStore';
import integrationsStore from 'src/mobx/integrationStore';
import { localeStore } from 'src/mobx/localesStore';
import { isDisabledByPos } from 'src/utils/helpers';
import { Checkbox } from 'src/view/components/Controls/Checkbox/Checkbox';
import Icon from 'src/view/components/Controls/Icon/Icon';
import IntegrationManager from 'src/view/components/IntegrationManager/IntegrationManager';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

const ModifiersOptions: React.FC = observer((): JSX.Element | null => {
  if (!modifiersStore.modifier) return null;

  const {
    optionName: nameRestrictionAccess,
    optionsPortion: portionRestrictionAccess,
    optionGlobalPrice: priceRestrictionAccess,
  } = integrationsStore.posRestrictions || {};

  return (
    <div className="modifiers-options mt-6 d-flex flex-column">
      <Text type={TEXT.SECTION_HEADER} text="options" />
      <div className="d-flex flex-column">
        {/* options */}
        <ul className="d-flex flex-column mt-4">
          {modifiersStore.modifier.options.length ? (
            <div className="d-flex flex-row">
              <Text
                type={TEXT.BLOCK_HEADER}
                text="hint_name"
                className={`modifier-option__input-name w-100 ${appStore.settings?.is_pos ? '' : 'ml-19'}`}
                disabled={isDisabledByPos(nameRestrictionAccess)}
                required
              />
              <Text
                type={TEXT.BLOCK_HEADER}
                text="portion"
                className="modifier-option__input-portion ml-3 w-100"
                disabled={isDisabledByPos(portionRestrictionAccess)}
              />
              <Text
                type={TEXT.BLOCK_HEADER}
                text="kcal_input_field_label"
                className="modifier-option__input-calories ml-3 w-100"
                disabled={isDisabledByPos(portionRestrictionAccess)}
              />
              <Text
                type={TEXT.BLOCK_HEADER}
                text="txt_price"
                className="modifier-option__input-price ml-3 w-100"
                disabled={isDisabledByPos(priceRestrictionAccess)}
                required
              />
              <Text type={TEXT.BLOCK_HEADER} text="external_id" className="modifier-option__input-external ml-3 w-100" />
            </div>
          ) : null}
          {modifiersStore.modifier.options.map((option) => (
            <ModifierOption key={option.id} option={option} />
          ))}
        </ul>
        {/* add option button */}
        <IntegrationManager
          setting={integrationsStore.posRestrictions?.addOptionToModifier}
          wrapperClassName="modifiers-options__button-add-wrapper mt-4"
          withTooltip
        >
          <button className="modifiers-options__button-add ml-19" onClick={() => modifiersStore.addOption()}>
            <div className="modifiers-options__button-add-icon">
              <Icon name={Icons.Plus} size={11} color={theme.colors.mainblue} />
            </div>
            <p className="family-medium text-size-16 color-mainblue ml-2">{localeStore.t('create_new_option')}</p>
          </button>
        </IntegrationManager>
        {/* checkboxes */}
        {!modifiersStore.modifier.is_draft ? (
          <div className="modifiers-options__checkbox-wrapper d-flex flex-column mt-4">
            <Checkbox
              value={Boolean(modifiersStore.modifier?.apply_price_in_linked_items)}
              name={MODIFIERS_CHECKBOX.APPLY_PRICE_IN_LINKED_ITEMS}
              label="apply_prices_linked_items"
              disabled={isDisabledByPos(priceRestrictionAccess)}
              onClick={(name) => modifiersStore.changePricesCheckBox(name)}
            />
            <Checkbox
              value={Boolean(modifiersStore.modifier.apply_price_in_branches)}
              name={MODIFIERS_CHECKBOX.APPLY_PRICE_IN_BRANCHES}
              label="apply_prices_branches_menus"
              disabled={!modifiersStore.modifier.apply_price_in_linked_items}
              onClick={(name) => modifiersStore.changePricesCheckBox(name)}
              className="mt-3 w-fit-content"
            />
          </div>
        ) : null}
      </div>
    </div>
  );
});

export default ModifiersOptions;
